let sagaMiddlewareInstance = null;

export const setSagaMiddleware = (sagaMiddleware) => {
  sagaMiddlewareInstance = sagaMiddleware;
};

export const getSagaMiddleware = () => (
  sagaMiddlewareInstance
);
